import { User } from "firebase/auth";
import { UploadResult } from "firebase/storage";
import { Collection, CollectionStage, CollectionState } from "../../../types";

export interface OnSubmitDraftCollectionProps {
  values: Collection | any;
  collectionProps: CollectionProps;
}

export type CollectionProps = {
  isMintCalendar: boolean;
  isDerivative: boolean;
  isNsfw: boolean;
  isDraft: boolean;
  mintDate: string;
  hasMintList: boolean;
  hasUploadMintList?: boolean
  mintHashList: string[];
  collectionThumbnail: string;
  collectionThumbnailUrl: string;
  setIsLoadingOverlayDisplay: (boolean: boolean) => void;
  collectionThumbnailName: string;
  collectionBannerName: string;
  mintHashListName: string;
  collectionBanner: string;
  collectionBannerUrl?: string;
  uploadJsonFile?: (
    objectStringified: string,
    userId: string,
    collectionName: string,
    filename: string
  ) => Promise<UploadResult>;
  getUserJWT: () => Promise<string> | undefined;
  currentUser: User | null;
  uploadImage?: (
    base64String: string,
    userId: string,
    collectionName: string,
    filename: string
  ) => Promise<UploadResult>;
  uploadFile: (
    file: File,
    progressChecker?: any
  ) => Promise<UploadResult>;
  collectionEmail: string;
  collectionOwner: string;
  collectionStage?: CollectionStage;
  collectionState: CollectionState;
  isReplaceMintList: boolean;
  requestId?: string;
  id: string;
  draftId?: string;
  collectionId: string;
  updateNameCheck: string;
  mintSupply?: number;
  mintPrice?: number;
  publish_to_mint_calendar?: boolean;
  bannerFile?: File;
  mintFile?: File;
  thumbnailFile?: File;
};

export enum Blockchain {
  Solana = "solana",
  Bitcoin = "bitcoin"
}